<ng-container
  *ngrxLet="{
    items: items$,
  } as vm"
>
  @if (field.label) {
    <fmnts-label class="form-field__label form-field__label--external">
      {{ field.label | translateInline }}
    </fmnts-label>
  }

  <fmnts-radio-group
    [(ngModel)]="value"
    class="fmnts-radio-group--collapsed-flex"
    [class.fmnts-radio-group--invalid]="showError"
  >
    @for (item of vm.items; track item) {
      <fmnts-radio-grid-item
        [value]="item.value"
        [attr.data-testid]="'radio-item-' + item.value"
      >
        {{ item.label | translateInline }}

        @if (item.description) {
          <div
            fmntsRadioButtonSuffix
            class="form-field__radio-button-description"
          >
            {{ item.description | translateInline }}
          </div>
        }
      </fmnts-radio-grid-item>
    }
  </fmnts-radio-group>

  <div class="form-field__error-message">
    @if (showError && control.errors) {
      <fmnts-form-error>
        {{ control.errors | declarativeErrorMessage: field : declaration }}
      </fmnts-form-error>
    }
  </div>
</ng-container>
